<div class="cookie-banner-container" *ngIf="!cookieConsent">
	<div class="cookie-banner-container-inner">
		<p>We use cookies to improve your experience on our website. By browsing this website, you agree to our use of cookies.</p>
		<button (click)="acceptCookies()">Accept</button>
	</div>
</div>
